import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { APIs } from 'src/app/config/api.constant';
import { AppConstant } from 'src/app/config/app.constant';
import { AppStateProvider } from 'src/app/providers/app-state.provider';
import { ApiService } from 'src/app/services/api.service';
import { DataService } from 'src/app/services/data.service';

@Component({
  standalone: false,
  selector: 'app-employee-add-status',
  templateUrl: './employee-add-status.component.html',
  styleUrls: ['./employee-add-status.component.scss']
})
export class EmployeeAddStatusComponent implements OnInit {
  meetingNav: { index: string; name: string; link: string; }[];
  url: string;
  userInfo: any;
  acronym: any;
  deptInfo: any;
  token: string;
  closeResult: string;

  @ViewChild("revokeInvitationOne", { static: false }) revokeInvitationOne: NgbModalRef;


  constructor(private router: Router, private modalService: NgbModal, private apiService: ApiService, private dataService: DataService, private appStateSrv: AppStateProvider) { }

  open(content) {
    this.modalService.open(content,
      { ariaLabelledBy: 'modal-basic-title', centered: true, windowClass: 'custom-class' }
    ).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }


  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }


  ngOnInit(): void {
    this.meetingNav = [
      {
        index: "1",
        name: "Employees",
        link: '/employees/employees-list/add-employees/employee-add-status'
      }
    ]

    const route = {
      index: "1",
      name: "Employees",
      link: '/employees/employees-list/add-employees/employee-add-status'
    };
    this.appStateSrv.setSideNavState(route);


    this.getApiauthorizationToken();
  }
  getEmployeeDetails() {
    this.url = APIs.getUserInfo;
    const param = {
      Id: localStorage.getItem(AppConstant.localStorage.selectedMember)
    }
    this.apiService.get(this.url, param).subscribe(
      (response: any) => {
        this.userInfo = response;
        this.getName()
        this.getDepartmentDetails();
      },
      err => console.log('error', err)
    );
  }

  getDepartmentDetails() {
    this.url = APIs.getUserDepartmentInfo;
    const param = {
      Id: localStorage.getItem(AppConstant.localStorage.selectedMember)
    }
    this.apiService.get(this.url, param).subscribe(
      (response: any) => {
        this.deptInfo = response;
        this.dataService.employeeDetails.next(this.deptInfo)
      },
      err => console.log('error', err)
    );
  }
  resendEmail() {
    //this.commonService.getApiauthorizationToken().subscribe((res) => {
    if (localStorage.getItem(AppConstant.localStorage.token) != null) {

      this.url = APIs.resendEmail;
      const param = {
        Id: this.userInfo.data.userId
      }

      this.apiService.post(this.url, '', param).subscribe(
        (response: any) => {

        },
        err => console.log('error', err)
      );
    }
    //});

  }

  openRevoke() {
    this.open(this.revokeInvitationOne);
  }


  revokeAccess() {
    const data = {
      id: this.userInfo.data.userId,
      tenantId: localStorage.getItem(AppConstant.localStorage.tenantId)
    };
    this.apiService.post(APIs.revokeAccess, data).subscribe(
      result => {
        console.log("result", result);
        this.modalService.dismissAll();
        this.router.navigate(['employees/employees-list'])
      },
      error => {
      }
    );
    // this.open(this.content);
  }
  getName() {
    const str = this.userInfo.data.userName;
    console.log('str', str);

    // var str = this.userInfo.UserName;
    // var matches = str.match(/\b(\w)/g); // ['J','S','O','N']
    this.acronym = this.generateInitials(str)

    console.log("this.acronym", this.acronym)
  }

  generateInitials(fullName: string): string {
    if (fullName !== '' && fullName !== null && fullName !== undefined)
      return (fullName.split(' ')[0].charAt(0).toUpperCase()) + ' ' + ((fullName.split(' ')[1] === undefined || fullName.split(' ')[1] === null) ? '' : fullName.split(' ')[1].charAt(0).toUpperCase());
    else
      return '';
  }


  getApiauthorizationToken() {
    //this.commonService.getApiauthorizationToken().subscribe((res) => {
    if (localStorage.getItem(AppConstant.localStorage.token) != null) {

      this.getEmployeeDetails();
    }
    //});
  };
  viewEmployeeDetails() {
    this.router.navigate(["/employees/employees-list/employee-details"]);
  }
  addEmployee() {
    this.router.navigate(["/employees/employees-list/add-employees"]);

  }
  bulkUploadEmployees() {
    this.router.navigate(["/employees/employees-list/bulk-upload-employees"]);
  }
}
